import { useContext } from 'react';

import { DataContext } from '../providers/data.provider';

export const useData = () => {
    return useContext(DataContext);
}

//connection